import { BaseService } from "./BaseService";

export class MemberService extends BaseService {
  constructor() {
    super("members");
  }
}